module.exports = new __parcel__URL__("floor-tom_12.24ed6b48.mp3").toString();